import React from 'react';
import { Card } from '@/Components/shadcn';
import { RecruitmentOverview } from '@/Models/RecruitmentOverview';
import RecruitmentListItemBody from './RecruitmentListItemBody';
import RecruitmentListItemFooter from './RecruitmentListItemFooter';
import { RecruitmentListItemHeader } from './RecruitmentListItemHeader';

interface RecruitmentListItemProps {
    recruitment: RecruitmentOverview;
}
function RecruitmentListItem({ recruitment }: RecruitmentListItemProps): React.JSX.Element {
    return (
        <Card className="w-full border p-5 drop-shadow" data-cy="recruitmentCard">
            <div className="flex flex-col gap-3">
                <RecruitmentListItemHeader recruitment={recruitment} />
                <RecruitmentListItemBody recruitment={recruitment} />
                <RecruitmentListItemFooter recruitment={recruitment} />
            </div>
        </Card>
    );
}

export default RecruitmentListItem;
